import { ConversationAnalysisFragment } from '@shared/generated/graphql';
import { ConversationAnalysis } from '@shared/types/conversationAnalysis';

export function conversationAnalysisFromFragment(
  fragment: ConversationAnalysisFragment
): ConversationAnalysis {
  return {
    id: fragment.id,
    type: fragment.type,
    name: fragment.name,
    status: fragment.status,
    results: fragment.results ?? undefined,
  };
}
